module.exports = __webpack_public_path__ + "./images/ceaca521b17ca72578f59e1b97f31f53.webp";